import { render, staticRenderFns } from "./Duration_Value.vue?vue&type=template&id=7cc679f1"
import script from "./Duration_Value.vue?vue&type=script&lang=js"
export * from "./Duration_Value.vue?vue&type=script&lang=js"
import style0 from "./Duration_Value.vue?vue&type=style&index=0&id=7cc679f1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports